import { SearchFilterNanoID } from '../searchFilters/searchFiltersTypes';
import { UserNanoID } from '../users/usersTypes';

const basePath = '/messages';

export class MessagePath {
  static index() {
    return basePath;
  }

  static compactIndex() {
    return `${basePath}/compact`;
  }

  static myMessages() {
    return `${basePath}/filters/my-messages`;
  }

  static compactMyMessages() {
    return `${basePath}/compact/filters/my-messages`;
  }

  static myTotalHours() {
    return `${basePath}/filters/my-total-hours`;
  }

  static userTotalHours(userNanoId: UserNanoID) {
    return `${basePath}/filters/user/${userNanoId}/total-hours`;
  }

  static unread() {
    return `${basePath}/filters/new`;
  }

  static onlyClients() {
    return `${basePath}/filters/from-clients`;
  }

  static visible() {
    return `${basePath}/filters/visible`;
  }

  static compactUnread() {
    return `${basePath}/compact/filters/new`;
  }

  static compactOnlyClients() {
    return `${basePath}/compact/filters/from-clients`;
  }

  static compactVisible() {
    return `${basePath}/compact/filters/visible`;
  }

  static filters(searchFilterNanoId: SearchFilterNanoID) {
    return `${basePath}/filters/${searchFilterNanoId}`;
  }

  static compactFilters(searchFilterNanoId: SearchFilterNanoID) {
    return `${basePath}/compact/filters/${searchFilterNanoId}`;
  }

  static userMessages(userNanoId: UserNanoID) {
    return `${basePath}/filters/user/${userNanoId}`;
  }
}
